<h1 mat-dialog-title>We are unable to link with {{data.institutionName || 'your bank'}}</h1>
<mat-dialog-content>
  Try linking again. In order to transfer funds, we need to verify your bank.
  If this keeps happening, reach out to us at <a href="mailto:{{contactEmail}}">{{contactEmail}}</a>
  or <a href="tel:{{contactPhone}}">{{contactPhone}}</a>.
</mat-dialog-content>
<div mat-dialog-actions class="flex row end-center">
  <button mat-button [mat-dialog-close]="false">Link later</button>
  <button mat-button [mat-dialog-close]="true" color="primary" *ngIf="!data.next">Try again</button>
  <button mat-button [mat-dialog-close]="true" color="primary" *ngIf="data.next">Try another provider</button>
</div>